export default "__VITE_ASSET__DeeZffyS__"